export enum LocalStorageKeys {
  DANEA_INTERVENTI_WEB_SESSION_KEY = 'danea-interventi-web-session'
}
